/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  GetUtenteRuoloUfficioParams,
  WsRispostaPaginataListUtenteRuoloUfficio,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Restituisce lista UtenteRuoloUfficio. Ordinabile per id, codiceFiscale
 * @summary Restituisce lista UtenteRuoloUfficio
 */
export const getUtenteRuoloUfficio = (
  params?: GetUtenteRuoloUfficioParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListUtenteRuoloUfficio>(
    {
      url: `/framework-cfg-utenti/utente-ruolo-ufficio`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetUtenteRuoloUfficioQueryKey = (
  params?: GetUtenteRuoloUfficioParams,
) =>
  [
    `/framework-cfg-utenti/utente-ruolo-ufficio`,
    ...(params ? [params] : []),
  ] as const;

export const getGetUtenteRuoloUfficioQueryOptions = <
  TData = Awaited<ReturnType<typeof getUtenteRuoloUfficio>>,
  TError = ErrorType<unknown>,
>(
  params?: GetUtenteRuoloUfficioParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUtenteRuoloUfficio>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getUtenteRuoloUfficio>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetUtenteRuoloUfficioQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUtenteRuoloUfficio>>
  > = ({ signal }) => getUtenteRuoloUfficio(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetUtenteRuoloUfficioQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUtenteRuoloUfficio>>
>;
export type GetUtenteRuoloUfficioQueryError = ErrorType<unknown>;

/**
 * @summary Restituisce lista UtenteRuoloUfficio
 */
export const useGetUtenteRuoloUfficio = <
  TData = Awaited<ReturnType<typeof getUtenteRuoloUfficio>>,
  TError = ErrorType<unknown>,
>(
  params?: GetUtenteRuoloUfficioParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getUtenteRuoloUfficio>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetUtenteRuoloUfficioQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
